<template>
	<div>
		<v-select
			class="body-1 area-filter"
			color="primary"
			:height="36"
			hide-details
			:item-text="itemText"
			:item-value="itemValue"
			:items="items"
			outline
			:menu-props="{ contentClass: 'type-select-content' }"
			:style="`color:${$appColors.primary}!important`"
			:value="selectedValue"
			@input="handleChange"
		></v-select>
	</div>
</template>

<script>
export default {
	name: 'select-filter',
	props: {
		items: {
			default: () => [],
			type: Array,
		},
		itemText: {
			type: String,
			default: 'name',
		},
		itemValue: {
			type: String,
			default: 'id',
		},
		selectedValue: {
			type: [Number, String, Object],
			default: null,
		},
		eventName: {
			type: String,
			required: true,
		},
	},
	methods: {
		handleChange(value) {
			this.$emit(this.eventName, value);
		},
	},
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/diagnosis/select-filter.vue